<template>
  <div
    class="page"
    ref="page"
    v-loading="loading"
    element-loading-text="加载中..."
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <div class="page-search" ref="search">
      <div class="search-row">
        <el-date-picker
          v-model="searchForm.invoiceStartDate"
          type="date"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
          :picker-options="startDatePickerOptions"
        ></el-date-picker>
        <el-date-picker
          v-model="searchForm.invoiceEndDate"
          type="date"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :picker-options="endDatePickerOptions"
        ></el-date-picker>
        <el-input
          v-model="searchForm.customerCode"
          placeholder="请输入客户编码"
        ></el-input>
        <el-input
          v-model="searchForm.customerName"
          placeholder="请输入客户名称"
        ></el-input>
        <el-input
          v-model="searchForm.branchCompanyCode"
          placeholder="请输入分公司编码"
          style="margin-right: 0;"
        ></el-input>
      </div>
      <div class="search-row">
        <el-input
          v-model="searchForm.branchCompanyName"
          placeholder="请输入分公司名称"
        ></el-input>
      </div>
    </div>
    <div class="search-row" style="justify-content: space-between">
      <div>
        <span style="font-weight: bold; font-size: 14px">动态模块展示选择：</span>
        <el-button type="default" @click="openModuleDialog">选择模块</el-button>
        <span style="font-weight: bold; font-size: 14px; margin-left: 20px">动态参数展示选择：</span>
        <el-button type="default" @click="openParamDialog">选择参数</el-button>
      </div>
      <div>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
        <el-button @click="handleExport">导出</el-button>
      </div>
    </div>
    <div class="page-table">
      <vxe-table
        :key="tableKey"
        border
        show-overflow
        ref="xTable"
        size="mini"
        resizable
        :data="tableData"
        :auto-resize="true"
        :fixed-header="true"
        :height="tableHeight"
        :show-footer="true"
        :footer-method="footerMethod"
        :span-method="spanMethod"
      >
        <vxe-column field="dateScope" width="100" title="统计期间"></vxe-column>
        <vxe-column field="companyName" width="100" title="分公司"></vxe-column>
        <vxe-column
          field="customerName"
          width="100"
          title="经销商"
        ></vxe-column>

        <!-- 销售额 -->
        <vxe-colgroup title="销售额" field="group1" header-align="center">
          <vxe-column
            field="companySaleAmount"
            width="100"
            title="公司销售"
          ></vxe-column>
          <vxe-column
            field="sellThroughAmount"
            width="100"
            title="平台动销"
          ></vxe-column>
          <vxe-column
            field="companySaleSellThroughAmount"
            width="100"
            title="小计"
          ></vxe-column>
        </vxe-colgroup>

        <!-- 总投入 -->
        <vxe-colgroup
          v-if="showModule('group2')"
          title="总投入"
          field="group2"
          header-align="center"
        >
          <vxe-column
            v-if="showColumn('zltrAmount')"
            field="zltrAmount"
            width="100"
            title="战略投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('gstctrAmount')"
            field="gstctrAmount"
            width="100"
            title="公司统筹投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('scjctrAmount')"
            field="scjctrAmount"
            width="100"
            title="市场基础投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('zxtrAmount')"
            field="zxtrAmount"
            width="100"
            title="专项投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('gstctrzyAmount')"
            field="gstctrzyAmount"
            width="100"
            title="公司统筹投入(专用)"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('blAmount')"
            field="blAmount"
            width="100"
            title="B类费用"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('zrcsgjAmount')"
            field="zrcsgjAmount"
            width="100"
            title="折让/厂商共建费用"
          ></vxe-column>
          <vxe-column
            field="trTotalAmount"
            width="100"
            title="小计"
          ></vxe-column>
        </vxe-colgroup>

        <!-- 汇总 -->
        <vxe-colgroup
          v-if="showModule('group3')"
          title="汇总"
          field="group3"
          header-align="center"
        >
          <vxe-column
            field="group3_firstSubjectName"
            width="100"
            title="一级科目"
          ></vxe-column>
          <vxe-column
            field="group3_secondSubjectName"
            width="100"
            title="二级科目"
          ></vxe-column>
          <vxe-column
            field="group3_schemeAmout"
            width="100"
            title="方案规划金额"
          ></vxe-column>
          <vxe-colgroup title="申请金额" field="group3-1" header-align="center">
            <vxe-column
              v-if="showColumn('zltrAmount')"
              field="group3_zltrApplyAmount"
              width="100"
              title="战略投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrAmount')"
              field="group3_gstctrApplyAmount"
              width="100"
              title="公司统筹投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('scjctrAmount')"
              field="group3_scjctrApplyAmount"
              width="100"
              title="市场基础投入"
            ></vxe-column>
            <vxe-column
              field="group3_zxtrApplyAmount"
              width="100"
              title="专项投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrzyAmount')"
              field="group3_gstctrzyApplyAmount"
              width="100"
              title="公司统筹投入(专用)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('blAmount')"
              field="group3_blApplyAmount"
              width="100"
              title="B类费用"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('zrcsgjAmount')"
              field="group3_zrcsgjApplyAmount"
              width="100"
              title="折让/厂商共建费用"
            ></vxe-column>
            <vxe-column
              field="group3_trTotalApplyAmount"
              width="100"
              title="小计"
            ></vxe-column>
            <vxe-column
              field="group3_applyRate"
              width="100"
              title="占比"
            ></vxe-column>
            <vxe-column
              field="group3_ztApplyAmount"
              width="100"
              title="直投金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('ztApplyAmount')"
              field="group3_jxsdfApplyAmount"
              width="100"
              title="经销商垫付金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('applyInvestRate')"
              field="group3_applyInvestRate"
              width="100"
              title="投入比(申请/投入)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('applyExecutionRate')"
              field="group3_applyExecutionRate"
              width="100"
              title="执行率(申请/规划)"
            ></vxe-column>
          </vxe-colgroup>
          <vxe-colgroup title="核销金额" field="group3-2" header-align="center">
            <vxe-column
              v-if="showColumn('zltrAmount')"
              field="group3_zltrAuditAmount"
              width="100"
              title="战略投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrAmount')"
              field="group3_gstctrAuditAmount"
              width="100"
              title="公司统筹投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('scjctrAmount')"
              field="group3_scjctrAuditAmount"
              width="100"
              title="市场基础投入"
            ></vxe-column>
            <vxe-column
              field="group3_zxtrAuditAmount"
              width="100"
              title="专项投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrzyAmount')"
              field="group3_gstctrzyAuditAmount"
              width="100"
              title="公司统筹投入(专用)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('blAmount')"
              field="group3_blAuditAmount"
              width="100"
              title="B类费用"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('zrcsgjAmount')"
              field="group3_zrcsgjAuditAmount"
              width="100"
              title="折让/厂商共建费用"
            ></vxe-column>
            <vxe-column
              field="group3_trTotalAuditAmount"
              width="100"
              title="小计"
            ></vxe-column>
            <vxe-column
              field="group3_ztAuditAmount"
              width="100"
              title="直投金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('ztApplyAmount')"
              field="group3_jxsdfAuditAmount"
              width="100"
              title="经销商垫付金额"
            ></vxe-column>
          </vxe-colgroup>
        </vxe-colgroup>

        <!-- 红西凤投入 -->
        <vxe-colgroup
          v-if="showModule('group4')"
          title="红西凤投入"
          field="group4"
          header-align="center"
        >
          <vxe-column
            v-if="showColumn('zltrAmount')"
            field="group4_zltrAmount"
            width="100"
            title="战略投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('gstctrAmount')"
            field="group4_gstctrAmount"
            width="100"
            title="公司统筹投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('scjctrAmount')"
            field="group4_scjctrAmount"
            width="100"
            title="市场基础投入"
          ></vxe-column>
          <vxe-column
            field="group4_zxtrAmount"
            width="100"
            title="专项投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('gstctrzyAmount')"
            field="group4_gstctrzyAmount"
            width="100"
            title="公司统筹投入(专用)"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('blAmount')"
            field="group4_blAmount"
            width="100"
            title="B类费用"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('zrcsgjAmount')"
            field="group4_zrcsgjAmount"
            width="100"
            title="折让/厂商共建费用"
          ></vxe-column>
          <vxe-column
            field="group4_trTotalAmount"
            width="100"
            title="小计"
          ></vxe-column>
        </vxe-colgroup>

        <!-- 红西凤系列 -->
        <vxe-colgroup
          v-if="showModule('group5')"
          title="红西凤系列"
          field="group5"
          header-align="center"
        >
          <vxe-column
            field="group5_firstSubjectName"
            width="100"
            title="一级科目"
          ></vxe-column>
          <vxe-column
            field="group5_secondSubjectName"
            width="100"
            title="二级科目"
          ></vxe-column>
          <vxe-column
            field="group5_schemeAmout"
            width="100"
            title="方案规划金额"
          ></vxe-column>
          <vxe-colgroup title="申请金额" field="group5-1" header-align="center">
            <vxe-column
              v-if="showColumn('zltrAmount')"
              field="group5_zltrApplyAmount"
              width="100"
              title="战略投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrAmount')"
              field="group5_gstctrApplyAmount"
              width="100"
              title="公司统筹投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('scjctrAmount')"
              field="group5_scjctrApplyAmount"
              width="100"
              title="市场基础投入"
            ></vxe-column>
            <vxe-column
              field="group5_zxtrApplyAmount"
              width="100"
              title="专项投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrzyAmount')"
              field="group5_gstctrzyApplyAmount"
              width="100"
              title="公司统筹投入(专用)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('blAmount')"
              field="group5_blApplyAmount"
              width="100"
              title="B类费用"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('zrcsgjAmount')"
              field="group5_zrcsgjApplyAmount"
              width="100"
              title="折让/厂商共建费用"
            ></vxe-column>
            <vxe-column
              field="group5_trTotalApplyAmount"
              width="100"
              title="小计"
            ></vxe-column>
            <vxe-column
              field="group5_applyRate"
              width="100"
              title="占比"
            ></vxe-column>
            <vxe-column
              field="group5_ztApplyAmount"
              width="100"
              title="直投金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('ztApplyAmount')"
              field="group5_jxsdfApplyAmount"
              width="100"
              title="经销商垫付金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('applyInvestRate')"
              field="group5_applyInvestRate"
              width="100"
              title="投入比(申请/投入)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('applyExecutionRate')"
              field="group5_applyExecutionRate"
              width="100"
              title="执行率(申请/规划)"
            ></vxe-column>
          </vxe-colgroup>
          <vxe-colgroup title="核销金额" field="group5-2" header-align="center">
            <vxe-column
              v-if="showColumn('zltrAmount')"
              field="group5_zltrAuditAmount"
              width="100"
              title="战略投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrAmount')"
              field="group5_gstctrAuditAmount"
              width="100"
              title="公司统筹投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('scjctrAmount')"
              field="group5_scjctrAuditAmount"
              width="100"
              title="市场基础投入"
            ></vxe-column>
            <vxe-column
              field="group5_zxtrAuditAmount"
              width="100"
              title="专项投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrzyAmount')"
              field="group5_gstctrzyAuditAmount"
              width="100"
              title="公司统筹投入(专用)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('blAmount')"
              field="group5_blAuditAmount"
              width="100"
              title="B类费用"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('zrcsgjAmount')"
              field="group5_zrcsgjAuditAmount"
              width="100"
              title="折让/厂商共建费用"
            ></vxe-column>
            <vxe-column
              field="group5_trTotalAuditAmount"
              width="100"
              title="小计"
            ></vxe-column>
            <vxe-column
              field="group5_ztAuditAmount"
              width="100"
              title="直投金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('ztApplyAmount')"
              field="group5_jxsdfAuditAmount"
              width="100"
              title="经销商垫付金额"
            ></vxe-column>
          </vxe-colgroup>
        </vxe-colgroup>

        <!-- 老绿瓶投入 -->
        <vxe-colgroup
          v-if="showModule('group6')"
          title="老绿瓶投入"
          field="group6"
          header-align="center"
        >
          <vxe-column
            v-if="showColumn('zltrAmount')"
            field="group6_zltrAmount"
            width="100"
            title="战略投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('gstctrAmount')"
            field="group6_gstctrAmount"
            width="100"
            title="公司统筹投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('scjctrAmount')"
            field="group6_scjctrAmount"
            width="100"
            title="市场基础投入"
          ></vxe-column>
          <vxe-column
            field="group6_zxtrAmount"
            width="100"
            title="专项投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('gstctrzyAmount')"
            field="group6_gstctrzyAmount"
            width="100"
            title="公司统筹投入(专用)"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('blAmount')"
            field="group6_blAmount"
            width="100"
            title="B类费用"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('zrcsgjAmount')"
            field="group6_zrcsgjAmount"
            width="100"
            title="折让/厂商共建费用"
          ></vxe-column>
          <vxe-column
            field="group6_trTotalAmount"
            width="100"
            title="小计"
          ></vxe-column>
        </vxe-colgroup>

        <!-- 老绿瓶系列 -->
        <vxe-colgroup
          v-if="showModule('group7')"
          title="老绿瓶系列"
          field="group7"
          header-align="center"
        >
          <vxe-column
            field="group7_firstSubjectName"
            width="100"
            title="一级科目"
          ></vxe-column>
          <vxe-column
            field="group7_secondSubjectName"
            width="100"
            title="二级科目"
          ></vxe-column>
          <vxe-column
            field="group7_schemeAmout"
            width="100"
            title="方案规划金额"
          ></vxe-column>
          <vxe-colgroup title="申请金额" field="group7-1" header-align="center">
            <vxe-column
              v-if="showColumn('zltrAmount')"
              field="group7_zltrApplyAmount"
              width="100"
              title="战略投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrAmount')"
              field="group7_gstctrApplyAmount"
              width="100"
              title="公司统筹投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('scjctrAmount')"
              field="group7_scjctrApplyAmount"
              width="100"
              title="市场基础投入"
            ></vxe-column>
            <vxe-column
              field="group7_zxtrApplyAmount"
              width="100"
              title="专项投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrzyAmount')"
              field="group7_gstctrzyApplyAmount"
              width="100"
              title="公司统筹投入(专用)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('blAmount')"
              field="group7_blApplyAmount"
              width="100"
              title="B类费用"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('zrcsgjAmount')"
              field="group7_zrcsgjApplyAmount"
              width="100"
              title="折让/厂商共建费用"
            ></vxe-column>
            <vxe-column
              field="group7_trTotalApplyAmount"
              width="100"
              title="小计"
            ></vxe-column>
            <vxe-column
              field="group7_applyRate"
              width="100"
              title="占比"
            ></vxe-column>
            <vxe-column
              field="group7_ztApplyAmount"
              width="100"
              title="直投金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('ztApplyAmount')"
              field="group7_jxsdfApplyAmount"
              width="100"
              title="经销商垫付金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('applyInvestRate')"
              field="group7_applyInvestRate"
              width="100"
              title="投入比(申请/投入)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('applyExecutionRate')"
              field="group7_applyExecutionRate"
              width="100"
              title="执行率(申请/规划)"
            ></vxe-column>
          </vxe-colgroup>
          <vxe-colgroup title="核销金额" field="group7-2" header-align="center">
            <vxe-column
              v-if="showColumn('zltrAmount')"
              field="group7_zltrAuditAmount"
              width="100"
              title="战略投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrAmount')"
              field="group7_gstctrAuditAmount"
              width="100"
              title="公司统筹投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('scjctrAmount')"
              field="group7_scjctrAuditAmount"
              width="100"
              title="市场基础投入"
            ></vxe-column>
            <vxe-column
              field="group7_zxtrAuditAmount"
              width="100"
              title="专项投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrzyAmount')"
              field="group7_gstctrzyAuditAmount"
              width="100"
              title="公司统筹投入(专用)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('blAmount')"
              field="group7_blAuditAmount"
              width="100"
              title="B类费用"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('zrcsgjAmount')"
              field="group7_zrcsgjAuditAmount"
              width="100"
              title="折让/厂商共建费用"
            ></vxe-column>
            <vxe-column
              field="group7_trTotalAuditAmount"
              width="100"
              title="小计"
            ></vxe-column>
            <vxe-column
              field="group7_ztAuditAmount"
              width="100"
              title="直投金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('ztApplyAmount')"
              field="group7_jxsdfAuditAmount"
              width="100"
              title="经销商垫付金额"
            ></vxe-column>
          </vxe-colgroup>
        </vxe-colgroup>

        <!-- 七彩投入 -->
        <vxe-colgroup
          v-if="showModule('group8')"
          title="七彩投入"
          field="group8"
          header-align="center"
        >
          <vxe-column
            v-if="showColumn('zltrAmount')"
            field="group8_zltrAmount"
            width="100"
            title="战略投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('gstctrAmount')"
            field="group8_gstctrAmount"
            width="100"
            title="公司统筹投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('scjctrAmount')"
            field="group8_scjctrAmount"
            width="100"
            title="市场基础投入"
          ></vxe-column>
          <vxe-column
            field="group8_zxtrAmount"
            width="100"
            title="专项投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('gstctrzyAmount')"
            field="group8_gstctrzyAmount"
            width="100"
            title="公司统筹投入(专用)"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('blAmount')"
            field="group8_blAmount"
            width="100"
            title="B类费用"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('zrcsgjAmount')"
            field="group8_zrcsgjAmount"
            width="100"
            title="折让/厂商共建费用"
          ></vxe-column>
          <vxe-column
            field="group8_trTotalAmount"
            width="100"
            title="小计"
          ></vxe-column>
        </vxe-colgroup>

        <!-- 七彩系列 -->
        <vxe-colgroup
          v-if="showModule('group9')"
          title="七彩系列"
          field="group9"
          header-align="center"
        >
          <vxe-column
            field="group9_firstSubjectName"
            width="100"
            title="一级科目"
          ></vxe-column>
          <vxe-column
            field="group9_secondSubjectName"
            width="100"
            title="二级科目"
          ></vxe-column>
          <vxe-column
            field="group9_schemeAmout"
            width="100"
            title="方案规划金额"
          ></vxe-column>
          <vxe-colgroup title="申请金额" field="group9-1" header-align="center">
            <vxe-column
              v-if="showColumn('zltrAmount')"
              field="group9_zltrApplyAmount"
              width="100"
              title="战略投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrAmount')"
              field="group9_gstctrApplyAmount"
              width="100"
              title="公司统筹投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('scjctrAmount')"
              field="group9_scjctrApplyAmount"
              width="100"
              title="市场基础投入"
            ></vxe-column>
            <vxe-column
              field="group9_zxtrApplyAmount"
              width="100"
              title="专项投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrzyAmount')"
              field="group9_gstctrzyApplyAmount"
              width="100"
              title="公司统筹投入(专用)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('blAmount')"
              field="group9_blApplyAmount"
              width="100"
              title="B类费用"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('zrcsgjAmount')"
              field="group9_zrcsgjApplyAmount"
              width="100"
              title="折让/厂商共建费用"
            ></vxe-column>
            <vxe-column
              field="group9_trTotalApplyAmount"
              width="100"
              title="小计"
            ></vxe-column>
            <vxe-column
              field="group9_applyRate"
              width="100"
              title="占比"
            ></vxe-column>
            <vxe-column
              field="group9_ztApplyAmount"
              width="100"
              title="直投金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('ztApplyAmount')"
              field="group9_jxsdfApplyAmount"
              width="100"
              title="经销商垫付金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('applyInvestRate')"
              field="group9_applyInvestRate"
              width="100"
              title="投入比(申请/投入)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('applyExecutionRate')"
              field="group9_applyExecutionRate"
              width="100"
              title="执行率(申请/规划)"
            ></vxe-column>
          </vxe-colgroup>
          <vxe-colgroup title="核销金额" field="group9-2" header-align="center">
            <vxe-column
              v-if="showColumn('zltrAmount')"
              field="group9_zltrAuditAmount"
              width="100"
              title="战略投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrAmount')"
              field="group9_gstctrAuditAmount"
              width="100"
              title="公司统筹投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('scjctrAmount')"
              field="group9_scjctrAuditAmount"
              width="100"
              title="市场基础投入"
            ></vxe-column>
            <vxe-column
              field="group9_zxtrAuditAmount"
              width="100"
              title="专项投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrzyAmount')"
              field="group9_gstctrzyAuditAmount"
              width="100"
              title="公司统筹投入(专用)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('blAmount')"
              field="group9_blAuditAmount"
              width="100"
              title="B类费用"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('zrcsgjAmount')"
              field="group9_zrcsgjAuditAmount"
              width="100"
              title="折让/厂商共建费用"
            ></vxe-column>
            <vxe-column
              field="group9_trTotalAuditAmount"
              width="100"
              title="小计"
            ></vxe-column>
            <vxe-column
              field="group9_ztAuditAmount"
              width="100"
              title="直投金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('ztApplyAmount')"
              field="group9_jxsdfAuditAmount"
              width="100"
              title="经销商垫付金额"
            ></vxe-column>
          </vxe-colgroup>
        </vxe-colgroup>

        <!-- 酒海投入 -->
        <vxe-colgroup
          v-if="showModule('group10')"
          title="酒海投入"
          field="group10"
          header-align="center"
        >
          <vxe-column
            v-if="showColumn('zltrAmount')"
            field="group10_zltrAmount"
            width="100"
            title="战略投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('gstctrAmount')"
            field="group10_gstctrAmount"
            width="100"
            title="公司统筹投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('scjctrAmount')"
            field="group10_scjctrAmount"
            width="100"
            title="市场基础投入"
          ></vxe-column>
          <vxe-column
            field="group10_zxtrAmount"
            width="100"
            title="专项投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('gstctrzyAmount')"
            field="group10_gstctrzyAmount"
            width="100"
            title="公司统筹投入(专用)"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('blAmount')"
            field="group10_blAmount"
            width="100"
            title="B类费用"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('zrcsgjAmount')"
            field="group10_zrcsgjAmount"
            width="100"
            title="折让/厂商共建费用"
          ></vxe-column>
          <vxe-column
            field="group10_trTotalAmount"
            width="100"
            title="小计"
          ></vxe-column>
        </vxe-colgroup>

        <!-- 酒海系列 -->
        <vxe-colgroup
          v-if="showModule('group11')"
          title="酒海系列"
          field="group11"
          header-align="center"
        >
          <vxe-column
            field="group11_firstSubjectName"
            width="100"
            title="一级科目"
          ></vxe-column>
          <vxe-column
            field="group11_secondSubjectName"
            width="100"
            title="二级科目"
          ></vxe-column>
          <vxe-column
            field="group11_schemeAmout"
            width="100"
            title="方案规划金额"
          ></vxe-column>
          <vxe-colgroup
            title="申请金额"
            field="group11-1"
            header-align="center"
          >
            <vxe-column
              v-if="showColumn('zltrAmount')"
              field="group11_zltrApplyAmount"
              width="100"
              title="战略投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrAmount')"
              field="group11_gstctrApplyAmount"
              width="100"
              title="公司统筹投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('scjctrAmount')"
              field="group11_scjctrApplyAmount"
              width="100"
              title="市场基础投入"
            ></vxe-column>
            <vxe-column
              field="group11_zxtrApplyAmount"
              width="100"
              title="专项投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrzyAmount')"
              field="group11_gstctrzyApplyAmount"
              width="100"
              title="公司统筹投入(专用)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('blAmount')"
              field="group11_blApplyAmount"
              width="100"
              title="B类费用"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('zrcsgjAmount')"
              field="group11_zrcsgjApplyAmount"
              width="100"
              title="折让/厂商共建费用"
            ></vxe-column>
            <vxe-column
              field="group11_trTotalApplyAmount"
              width="100"
              title="小计"
            ></vxe-column>
            <vxe-column
              field="group11_applyRate"
              width="100"
              title="占比"
            ></vxe-column>
            <vxe-column
              field="group11_ztApplyAmount"
              width="100"
              title="直投金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('ztApplyAmount')"
              field="group11_jxsdfApplyAmount"
              width="100"
              title="经销商垫付金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('applyInvestRate')"
              field="group11_applyInvestRate"
              width="100"
              title="投入比(申请/投入)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('applyExecutionRate')"
              field="group11_applyExecutionRate"
              width="100"
              title="执行率(申请/规划)"
            ></vxe-column>
          </vxe-colgroup>
          <vxe-colgroup
            title="核销金额"
            field="group11-2"
            header-align="center"
          >
            <vxe-column
              v-if="showColumn('zltrAmount')"
              field="group11_zltrAuditAmount"
              width="100"
              title="战略投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrAmount')"
              field="group11_gstctrAuditAmount"
              width="100"
              title="公司统筹投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('scjctrAmount')"
              field="group11_scjctrAuditAmount"
              width="100"
              title="市场基础投入"
            ></vxe-column>
            <vxe-column
              field="group11_zxtrAuditAmount"
              width="100"
              title="专项投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrzyAmount')"
              field="group11_gstctrzyAuditAmount"
              width="100"
              title="公司统筹投入(专用)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('blAmount')"
              field="group11_blAuditAmount"
              width="100"
              title="B类费用"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('zrcsgjAmount')"
              field="group11_zrcsgjAuditAmount"
              width="100"
              title="折让/厂商共建费用"
            ></vxe-column>
            <vxe-column
              field="group11_trTotalAuditAmount"
              width="100"
              title="小计"
            ></vxe-column>
            <vxe-column
              field="group11_ztAuditAmount"
              width="100"
              title="直投金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('ztApplyAmount')"
              field="group11_jxsdfAuditAmount"
              width="100"
              title="经销商垫付金额"
            ></vxe-column>
          </vxe-colgroup>
        </vxe-colgroup>

        <!-- 旗帜投入 -->
        <vxe-colgroup
          v-if="showModule('group12')"
          title="旗帜投入"
          field="group12"
          header-align="center"
        >
          <vxe-column
            v-if="showColumn('zltrAmount')"
            field="group12_zltrAmount"
            width="100"
            title="战略投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('gstctrAmount')"
            field="group12_gstctrAmount"
            width="100"
            title="公司统筹投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('scjctrAmount')"
            field="group12_scjctrAmount"
            width="100"
            title="市场基础投入"
          ></vxe-column>
          <vxe-column
            field="group12_zxtrAmount"
            width="100"
            title="专项投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('gstctrzyAmount')"
            field="group12_gstctrzyAmount"
            width="100"
            title="公司统筹投入(专用)"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('blAmount')"
            field="group12_blAmount"
            width="100"
            title="B类费用"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('zrcsgjAmount')"
            field="group12_zrcsgjAmount"
            width="100"
            title="折让/厂商共建费用"
          ></vxe-column>
          <vxe-column
            field="group12_trTotalAmount"
            width="100"
            title="小计"
          ></vxe-column>
        </vxe-colgroup>

        <!-- 旗帜系列 -->
        <vxe-colgroup
          v-if="showModule('group13')"
          title="旗帜系列"
          field="group13"
          header-align="center"
        >
          <vxe-column
            field="group13_firstSubjectName"
            width="100"
            title="一级科目"
          ></vxe-column>
          <vxe-column
            field="group13_secondSubjectName"
            width="100"
            title="二级科目"
          ></vxe-column>
          <vxe-column
            field="group13_schemeAmout"
            width="100"
            title="方案规划金额"
          ></vxe-column>
          <vxe-colgroup
            title="申请金额"
            field="group13-1"
            header-align="center"
          >
            <vxe-column
              v-if="showColumn('zltrAmount')"
              field="group13_zltrApplyAmount"
              width="100"
              title="战略投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrAmount')"
              field="group13_gstctrApplyAmount"
              width="100"
              title="公司统筹投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('scjctrAmount')"
              field="group13_scjctrApplyAmount"
              width="100"
              title="市场基础投入"
            ></vxe-column>
            <vxe-column
              field="group13_zxtrApplyAmount"
              width="100"
              title="专项投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrzyAmount')"
              field="group13_gstctrzyApplyAmount"
              width="100"
              title="公司统筹投入(专用)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('blAmount')"
              field="group13_blApplyAmount"
              width="100"
              title="B类费用"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('zrcsgjAmount')"
              field="group13_zrcsgjApplyAmount"
              width="100"
              title="折让/厂商共建费用"
            ></vxe-column>
            <vxe-column
              field="group13_trTotalApplyAmount"
              width="100"
              title="小计"
            ></vxe-column>
            <vxe-column
              field="group13_applyRate"
              width="100"
              title="占比"
            ></vxe-column>
            <vxe-column
              field="group13_ztApplyAmount"
              width="100"
              title="直投金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('ztApplyAmount')"
              field="group13_jxsdfApplyAmount"
              width="100"
              title="经销商垫付金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('applyInvestRate')"
              field="group13_applyInvestRate"
              width="100"
              title="投入比(申请/投入)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('applyExecutionRate')"
              field="group13_applyExecutionRate"
              width="100"
              title="执行率(申请/规划)"
            ></vxe-column>
          </vxe-colgroup>
          <vxe-colgroup
            title="核销金额"
            field="group13-2"
            header-align="center"
          >
            <vxe-column
              v-if="showColumn('zltrAmount')"
              field="group13_zltrAuditAmount"
              width="100"
              title="战略投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrAmount')"
              field="group13_gstctrAuditAmount"
              width="100"
              title="公司统筹投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('scjctrAmount')"
              field="group13_scjctrAuditAmount"
              width="100"
              title="市场基础投入"
            ></vxe-column>
            <vxe-column
              field="group13_zxtrAuditAmount"
              width="100"
              title="专项投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrzyAmount')"
              field="group13_gstctrzyAuditAmount"
              width="100"
              title="公司统筹投入(专用)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('blAmount')"
              field="group13_blAuditAmount"
              width="100"
              title="B类费用"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('zrcsgjAmount')"
              field="group13_zrcsgjAuditAmount"
              width="100"
              title="折让/厂商共建费用"
            ></vxe-column>
            <vxe-column
              field="group13_trTotalAuditAmount"
              width="100"
              title="小计"
            ></vxe-column>
            <vxe-column
              field="group13_ztAuditAmount"
              width="100"
              title="直投金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('ztApplyAmount')"
              field="group13_jxsdfAuditAmount"
              width="100"
              title="经销商垫付金额"
            ></vxe-column>
          </vxe-colgroup>
        </vxe-colgroup>

        <!-- 其他投入 -->
        <vxe-colgroup
          v-if="showModule('group14')"
          title="其他投入"
          field="group14"
          header-align="center"
        >
          <vxe-column
            v-if="showColumn('zltrAmount')"
            field="group14_zltrAmount"
            width="100"
            title="战略投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('gstctrAmount')"
            field="group14_gstctrAmount"
            width="100"
            title="公司统筹投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('scjctrAmount')"
            field="group14_scjctrAmount"
            width="100"
            title="市场基础投入"
          ></vxe-column>
          <vxe-column
            field="group14_zxtrAmount"
            width="100"
            title="专项投入"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('gstctrzyAmount')"
            field="group14_gstctrzyAmount"
            width="100"
            title="公司统筹投入(专用)"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('blAmount')"
            field="group14_blAmount"
            width="100"
            title="B类费用"
          ></vxe-column>
          <vxe-column
            v-if="showColumn('zrcsgjAmount')"
            field="group14_zrcsgjAmount"
            width="100"
            title="折让/厂商共建费用"
          ></vxe-column>
          <vxe-column
            field="group14_trTotalAmount"
            width="100"
            title="小计"
          ></vxe-column>
        </vxe-colgroup>

        <!-- 其他系列 -->
        <vxe-colgroup
          v-if="showModule('group15')"
          title="其他系列"
          field="group15"
          header-align="center"
        >
          <vxe-column
            field="group15_firstSubjectName"
            width="100"
            title="一级科目"
          ></vxe-column>
          <vxe-column
            field="group15_secondSubjectName"
            width="100"
            title="二级科目"
          ></vxe-column>
          <vxe-column
            field="group15_schemeAmout"
            width="100"
            title="方案规划金额"
          ></vxe-column>
          <vxe-colgroup
            title="申请金额"
            field="group15-1"
            header-align="center"
          >
            <vxe-column
              v-if="showColumn('zltrAmount')"
              field="group15_zltrApplyAmount"
              width="100"
              title="战略投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrAmount')"
              field="group15_gstctrApplyAmount"
              width="100"
              title="公司统筹投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('scjctrAmount')"
              field="group15_scjctrApplyAmount"
              width="100"
              title="市场基础投入"
            ></vxe-column>
            <vxe-column
              field="group15_zxtrApplyAmount"
              width="100"
              title="专项投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrzyAmount')"
              field="group15_gstctrzyApplyAmount"
              width="100"
              title="公司统筹投入(专用)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('blAmount')"
              field="group15_blApplyAmount"
              width="100"
              title="B类费用"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('zrcsgjAmount')"
              field="group15_zrcsgjApplyAmount"
              width="100"
              title="折让/厂商共建费用"
            ></vxe-column>
            <vxe-column
              field="group15_trTotalApplyAmount"
              width="100"
              title="小计"
            ></vxe-column>
            <vxe-column
              field="group15_applyRate"
              width="100"
              title="占比"
            ></vxe-column>
            <vxe-column
              field="group15_ztApplyAmount"
              width="100"
              title="直投金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('ztApplyAmount')"
              field="group15_jxsdfApplyAmount"
              width="100"
              title="经销商垫付金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('applyInvestRate')"
              field="group15_applyInvestRate"
              width="100"
              title="投入比(申请/投入)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('applyExecutionRate')"
              field="group15_applyExecutionRate"
              width="100"
              title="执行率(申请/规划)"
            ></vxe-column>
          </vxe-colgroup>
          <vxe-colgroup
            title="核销金额"
            field="group15-2"
            header-align="center"
          >
            <vxe-column
              v-if="showColumn('zltrAmount')"
              field="group15_zltrAuditAmount"
              width="100"
              title="战略投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrAmount')"
              field="group15_gstctrAuditAmount"
              width="100"
              title="公司统筹投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('scjctrAmount')"
              field="group15_scjctrAuditAmount"
              width="100"
              title="市场基础投入"
            ></vxe-column>
            <vxe-column
              field="group15_zxtrAuditAmount"
              width="100"
              title="专项投入"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('gstctrzyAmount')"
              field="group15_gstctrzyAuditAmount"
              width="100"
              title="公司统筹投入(专用)"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('blAmount')"
              field="group15_blAuditAmount"
              width="100"
              title="B类费用"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('zrcsgjAmount')"
              field="group15_zrcsgjAuditAmount"
              width="100"
              title="折让/厂商共建费用"
            ></vxe-column>
            <vxe-column
              field="group15_trTotalAuditAmount"
              width="100"
              title="小计"
            ></vxe-column>
            <vxe-column
              field="group15_ztAuditAmount"
              width="100"
              title="直投金额"
            ></vxe-column>
            <vxe-column
              v-if="showColumn('ztApplyAmount')"
              field="group15_jxsdfAuditAmount"
              width="100"
              title="经销商垫付金额"
            ></vxe-column>
          </vxe-colgroup>
        </vxe-colgroup>
      </vxe-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageNum"
          :page-sizes="[15, 20, 25]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="动态模块展示选择"
      :visible.sync="showModuleDialog"
      width="600px"
      @close="showModuleDialog = false"
      append-to-body
    >
      <el-checkbox-group v-model="tempModuleChooseKey">
        <el-checkbox
          v-for="item in moduleOptions"
          :key="item.value"
          :label="item.value"
        >
          {{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleModuleCancel">取消</el-button>
        <el-button type="primary" @click="handleModuleConfirm">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="动态参数展示选择"
      :visible.sync="showParamDialog"
      width="600px"
      @close="showParamDialog = false"
      append-to-body
    >
      <el-checkbox-group v-model="tempParamChooseKey">
        <el-checkbox
          v-for="item in paramOptions"
          :key="item.value"
          :label="item.value"
        >
          {{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleParamCancel">取消</el-button>
        <el-button type="primary" @click="handleParamConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import request from '@/found/utils/request';
import axios from 'axios';

export default {
  name: 'Table2',
  data() {
    const moduleOptions = [
      { label: '总投入', value: 'group2' },
      { label: '汇总', value: 'group3' },
      { label: '红西凤投入', value: 'group4' },
      { label: '红西凤系列', value: 'group5' },
      { label: '老绿瓶投入', value: 'group6' },
      { label: '老绿瓶系列', value: 'group7' },
      { label: '七彩投入', value: 'group8' },
      { label: '七彩系列', value: 'group9' },
      { label: '酒海投入', value: 'group10' },
      { label: '酒海系列', value: 'group11' },
      { label: '旗帜投入', value: 'group12' },
      { label: '旗帜系列', value: 'group13' },
      { label: '其他投入', value: 'group14' },
      { label: '其他系列', value: 'group15' },
    ];

    const paramOptions = [
      { label: '战略投入', value: 'zltrAmount' },
      { label: '公司统筹投入', value: 'gstctrAmount' },
      { label: '市场基础投入', value: 'scjctrAmount' },
      { label: '专项投入', value: 'zxtrAmount' },
      { label: '公司统筹投入(专用)', value: 'gstctrzyAmount' },
      { label: 'B类费用', value: 'blAmount' },
      { label: '折让/厂商共建费用', value: 'zrcsgjAmount' },
      { label: '经销商垫付金额', value: 'ztApplyAmount' },
      { label: '投入比(申请/投入)', value: 'applyInvestRate' },
      { label: '执行率(申请/规划)', value: 'applyExecutionRate' },
    ];

    return {
      tableData: [],
      moduleOptions,
      paramOptions,
      moduleChooseKey: moduleOptions.map((item) => item.value),
      paramChooseKey: paramOptions.map((item) => item.value),
      tempModuleChooseKey: moduleOptions.map((item) => item.value),
      tempParamChooseKey: paramOptions.map((item) => item.value),
      tableKey: 0,
      isCalculateHeight: true,
      otherHeight: 101,
      searchOpenHeight: 0,
      tableHeight: this.setPageHeight(),
      screenHeight: window.innerHeight,
      searchForm: {
        invoiceStartDate: this.getYesterday(),
        invoiceEndDate: this.getToday(),
        customerCode: '',
        customerName: '',
        branchCompanyCode: '',
        branchCompanyName: '',
      },
      showModuleDialog: false,
      showParamDialog: false,
      pagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      loading: false,
    };
  },
  computed: {
    startDatePickerOptions() {
      return {
        disabledDate: (time) => {
          if (this.searchForm.invoiceEndDate) {
            return (
              time.getTime()
              > new Date(this.searchForm.invoiceEndDate).getTime()
            );
          }
          return false;
        },
      };
    },
    endDatePickerOptions() {
      return {
        disabledDate: (time) => {
          if (this.searchForm.invoiceStartDate) {
            return (
              time.getTime()
              < new Date(this.searchForm.invoiceStartDate).getTime()
            );
          }
          return false;
        },
      };
    },
  },
  watch: {
    screenHeight(val) {
      this.setPageHeight();
    },
    tableData(val) {
      this.setPageHeight();
    },
  },
  mounted() {
    window.onresize = () => (() => {
      window.screenHeight = window.innerHeight;
      this.screenHeight = window.screenHeight;
      this.setPageHeight();
    })();
    this.getTableData();
  },
  methods: {
    getToday() {
      const date = new Date();
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        '0',
      )}-${String(date.getDate()).padStart(2, '0')}`;
    },
    getYesterday() {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        '0',
      )}-${String(date.getDate()).padStart(2, '0')}`;
    },
    async getTableData() {
      if (
        !this.searchForm.invoiceStartDate
        || !this.searchForm.invoiceEndDate
      ) {
        return this.$message.error('请选择开始日期和结束日期!');
      }
      this.loading = true;
      const params = {
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        invoiceStartDate: this.searchForm.invoiceStartDate,
        invoiceEndDate: this.searchForm.invoiceEndDate,
        customerCode: this.searchForm.customerCode || '',
        customerName: this.searchForm.customerName || '',
        branchCompanyCode: this.searchForm.branchCompanyCode || '',
        branchCompanyName: this.searchForm.branchCompanyName || '',
      };

      const res = await request.post(
        '/tpm/tpmCustomerBigDataReport/queryTreePage',
        params,
      );
      this.loading = false;

      if (res && res.result && res.result.data) {
        const results = [];
        res.result.data.forEach((rawData) => {
          results.push(...this.transformData(rawData));
        });
        this.tableData = results;
        this.pagination.total = res.result.count || 0;
        if (this.paramChooseKey.length < this.paramOptions.length) {
          this.recalculateSubtotal();
        }
        this.$nextTick(() => {
          this.setPageHeight();
        });
      }
    },
    handleSearch() {
      this.pagination.pageNum = 1;
      this.getTableData();
    },
    async handleExport() {
      this.loading = true;
      const params = {
        ...this.searchForm,
      };
      if (!params.invoiceStartDate || !params.invoiceEndDate) {
        this.loading = false;
        return this.$message.error('请选择开始日期和结束日期!');
      }
      try {
        // 新建纯净axios实例，不受全局拦截器篡改error
        const exportAxios = axios.create();
        const token = localStorage.getItem('TokenKey');
        const res = await exportAxios.post(
          '/tpm/tpmCustomerBigDataReport/exportWideListExcel',
          params,
          {
            responseType: 'blob',
            headers: {
              loginUserToken: token,
            },
          },
        );
        // 校验是否返回JSON报错（兼容500/400场景）
        const contentType = res.headers['content-type'] || '';
        if (contentType.includes('application/json')) {
          const reader = new FileReader();
          reader.readAsText(res.data);
          reader.onload = (e) => {
            const msg = JSON.parse(e.target.result).msg || '服务端导出失败';
            this.$message.error(msg);
          };
          return;
        }

        // 1. 移除文件名特殊符号&，彻底规避download属性报错
        const fileName = '投入和活动申请-活动类型维度报表.xlsx';
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const blobUrl = URL.createObjectURL(blob);

        // 2. 优化DOM操作，同步执行不丢时序
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = blobUrl;
        a.download = fileName;
        document.body.appendChild(a);
        // 同步点击，不依赖setTimeout
        a.click();
        // 立刻清理，防止内存泄漏触发异常
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);

        this.$message.success('导出成功');
      } catch (realErr) {
        // 这次能打印真实报错堆栈，不再是Blob
        console.error('真实导出异常堆栈：', realErr);
        this.$message.error('导出失败，请查看控制台详情');
      } finally {
        this.loading = false;
      }
    },
    handleReset() {
      this.searchForm = {
        invoiceStartDate: '',
        invoiceEndDate: '',
        customerCode: '',
        customerName: '',
      };
      this.pagination = {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      };
      this.tableData = [];
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.pageNum = 1;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
      this.getTableData();
    },
    openModuleDialog() {
      this.tempModuleChooseKey = [...this.moduleChooseKey];
      this.showModuleDialog = true;
    },
    handleModuleConfirm() {
      this.moduleChooseKey = [...this.tempModuleChooseKey];
      this.showModuleDialog = false;
      this.$nextTick(() => {
        this.tableKey += 1;
      });
    },
    handleModuleCancel() {
      this.tempModuleChooseKey = [...this.moduleChooseKey];
      this.showModuleDialog = false;
    },
    openParamDialog() {
      this.tempParamChooseKey = [...this.paramChooseKey];
      this.showParamDialog = true;
    },
    handleParamConfirm() {
      this.paramChooseKey = [...this.tempParamChooseKey];
      this.showParamDialog = false;
      this.recalculateSubtotal();
      this.$nextTick(() => {
        this.tableKey += 1;
      });
    },
    handleParamCancel() {
      this.tempParamChooseKey = [...this.paramChooseKey];
      this.showParamDialog = false;
    },
    recalculateSubtotal() {
      const amountFields = [
        'zltrAmount',
        'gstctrAmount',
        'scjctrAmount',
        'zxtrAmount',
        'gstctrzyAmount',
        'blAmount',
        'zrcsgjAmount',
      ];
      const inputModules = [
        '',
        'group3_',
        'group4_',
        'group6_',
        'group8_',
        'group10_',
        'group12_',
        'group14_',
      ];
      const seriesModules = [
        'group5_',
        'group7_',
        'group9_',
        'group11_',
        'group13_',
        'group15_',
      ];
      const modules = [...inputModules, ...seriesModules];
      this.tableData.forEach((row, rowIndex) => {
        const updatedRow = { ...row };
        modules.forEach((prefix) => {
          const subtotal = this.calculateSingleSubtotal(
            row,
            amountFields,
            prefix,
          );
          updatedRow[`${prefix}trTotalAmount`] = subtotal;
        });
        // 重新计算申请金额小计（汇总和各系列）
        const applyModules = [
          'group3_',
          'group5_',
          'group7_',
          'group9_',
          'group11_',
          'group13_',
          'group15_',
        ];
        applyModules.forEach((prefix) => {
          const applySubtotal = this.calculateSingleSubtotal(
            row,
            amountFields,
            prefix,
            'ApplyAmount',
          );
          updatedRow[`${prefix}trTotalApplyAmount`] = applySubtotal;
        });
        // 重新计算核销金额小计（汇总和各系列）
        const auditModules = [
          'group3_',
          'group5_',
          'group7_',
          'group9_',
          'group11_',
          'group13_',
          'group15_',
        ];
        auditModules.forEach((prefix) => {
          const auditSubtotal = this.calculateSingleSubtotal(
            row,
            amountFields,
            prefix,
            'AuditAmount',
          );
          updatedRow[`${prefix}trTotalAuditAmount`] = auditSubtotal;
        });
        this.tableData[rowIndex] = updatedRow;
      });
    },
    calculateSingleSubtotal(row, amountFields, prefix, suffix = '') {
      let subtotal = 0;
      amountFields.forEach((field) => {
        let fullField;
        if (suffix) {
          const baseField = field.replace('Amount', '');
          fullField = `${prefix}${baseField}${suffix}`;
        } else {
          fullField = `${prefix}${field}`;
        }
        if (this.paramChooseKey.includes(field)) {
          subtotal += row[fullField] || 0;
        }
      });
      return subtotal;
    },
    calculateSeriesSubtotal(row, amountFields) {
      const seriesMappings = [
        { input: 'group4', series: 'group5' },
        { input: 'group6', series: 'group7' },
        { input: 'group8', series: 'group9' },
        { input: 'group10', series: 'group11' },
        { input: 'group12', series: 'group13' },
        { input: 'group14', series: 'group15' },
      ];
      seriesMappings.forEach((mapping) => {
        let inputSubtotal = 0;
        let seriesSubtotal = 0;
        amountFields.forEach((field) => {
          if (this.paramChooseKey.includes(field)) {
            inputSubtotal += row[`${mapping.input}_${field}`] || 0;
            seriesSubtotal += row[`${mapping.series}_${field}`] || 0;
          }
        });
        row[`${mapping.input}_trTotalAmount`] = inputSubtotal; // eslint-disable-line no-param-reassign
        row[`${mapping.series}_trTotalAmount`] = seriesSubtotal; // eslint-disable-line no-param-reassign
      });
    },
    calculateApplyAuditSubtotal(row, amountFields) {
      const seriesMappings = [
        { input: 'group3', series: 'group3' },
        { input: 'group4', series: 'group5' },
        { input: 'group6', series: 'group7' },
        { input: 'group8', series: 'group9' },
        { input: 'group10', series: 'group11' },
        { input: 'group12', series: 'group13' },
        { input: 'group14', series: 'group15' },
      ];
      seriesMappings.forEach((mapping) => {
        let applySubtotal = 0;
        let auditSubtotal = 0;
        amountFields.forEach((field) => {
          if (this.paramChooseKey.includes(field)) {
            const baseField = field.replace('Amount', '');
            applySubtotal
              += row[`${mapping.series}_${baseField}ApplyAmount`] || 0;
            auditSubtotal
              += row[`${mapping.series}_${baseField}AuditAmount`] || 0;
          }
        });
        row[`${mapping.series}_trTotalApplyAmount`] = applySubtotal; // eslint-disable-line no-param-reassign
        row[`${mapping.series}_trTotalAuditAmount`] = auditSubtotal; // eslint-disable-line no-param-reassign
      });
    },

    setPageHeight() {
      this.$nextTick(() => {
        if (this.$refs.search) {
          const searchRect = this.$refs.search.getBoundingClientRect();
          this.searchOpenHeight = searchRect.height - 44;
        }
        if (this.$refs.page) {
          const pageRect = this.$refs.page.getBoundingClientRect();
          const pageHeight = pageRect.height;
          this.tableHeight = pageHeight - this.otherHeight - this.searchOpenHeight;
        }
      });
      return 600;
    },

    transformData(rawData) {
      const result = [];

      const productSeriesMapping = {
        hxf: { input: 'group4', series: 'group5' },
        llp: { input: 'group6', series: 'group7' },
        qc: { input: 'group8', series: 'group9' },
        jhcc: { input: 'group10', series: 'group11' },
        qz: { input: 'group12', series: 'group13' },
        OTHER: { input: 'group14', series: 'group15' },
      };

      const totalAmountFields = [
        'zltrAmount',
        'gstctrAmount',
        'scjctrAmount',
        'zxtrAmount',
        'gstctrzyAmount',
        'blAmount',
        'zrcsgjAmount',
        'trTotalAmount',
      ];

      const applyAmountFields = [
        'zltrApplyAmount',
        'gstctrApplyAmount',
        'scjctrApplyAmount',
        'zxtrApplyAmount',
        'gstctrzyApplyAmount',
        'blApplyAmount',
        'zrcsgjApplyAmount',
        'trTotalApplyAmount',
        'ztApplyAmount',
        'jxsdfApplyAmount',
        'applyRate',
        'applyInvestRate',
        'applyExecutionRate',
      ];

      const auditAmountFields = [
        'zltrAuditAmount',
        'gstctrAuditAmount',
        'scjctrAuditAmount',
        'zxtrAuditAmount',
        'gstctrzyAuditAmount',
        'blAuditAmount',
        'zrcsgjAuditAmount',
        'trTotalAuditAmount',
        'ztAuditAmount',
        'jxsdfAuditAmount',
      ];

      const group2Total = {
        zltrAmount: 0,
        gstctrAmount: 0,
        scjctrAmount: 0,
        zxtrAmount: 0,
        gstctrzyAmount: 0,
        blAmount: 0,
        zrcsgjAmount: 0,
        trTotalAmount: 0,
      };

      rawData.detailtList.forEach((detail) => {
        totalAmountFields.forEach((field) => {
          group2Total[field] += detail[field] || 0;
        });
      });

      const summaryDetail = rawData.detailtList.find((d) => d.mainFlag === 'Y');
      const seriesDetails = rawData.detailtList.filter(
        (d) => d.mainFlag !== 'Y',
      );

      const allSubjectCounts = [
        ...seriesDetails.map((d) => (d.detailSubjectList || []).length),
        (summaryDetail?.detailSubjectList || []).length,
      ];
      const maxSubjectCount = Math.max(...allSubjectCounts, 1);

      for (let rowIndex = 0; rowIndex < maxSubjectCount; rowIndex += 1) {
        const row = {
          customerCode: rawData.customerCode,
          customerRowIndex: rowIndex,
          customerTotalRows: maxSubjectCount,
          dateScope: rowIndex === 0 ? rawData.dateScope : '',
          companyName: rowIndex === 0 ? rawData.branchCompanyName : '',
          customerName: rowIndex === 0 ? rawData.customerName : '',
          companySaleAmount: rowIndex === 0 ? rawData.companySaleAmount : 0,
          sellThroughAmount: rowIndex === 0 ? rawData.sellThroughAmount : 0,
          companySaleSellThroughAmount:
            rowIndex === 0 ? rawData.companySaleSellThroughAmount : 0,
        };

        totalAmountFields.forEach((field) => {
          row[field] = rowIndex === 0 ? group2Total[field] : 0;
        });

        if (summaryDetail) {
          totalAmountFields.forEach((field) => {
            row[`group3_${field}`] = rowIndex === 0 ? summaryDetail[field] || 0 : 0;
          });

          const summarySubjects = summaryDetail.detailSubjectList || [];
          const summarySubject = summarySubjects[rowIndex];

          if (summarySubject) {
            row.group3_firstSubjectName = summarySubject.firstSubjectName;
            row.group3_secondSubjectName = summarySubject.secondSubjectName;
            row.group3_schemeAmout = summarySubject.schemeAmout;

            applyAmountFields.forEach((field) => {
              row[`group3_${field}`] = summarySubject[field] || 0;
            });

            auditAmountFields.forEach((field) => {
              row[`group3_${field}`] = summarySubject[field] || 0;
            });
          } else {
            row.group3_firstSubjectName = '';
            row.group3_secondSubjectName = '';
            row.group3_schemeAmout = 0;

            applyAmountFields.forEach((field) => {
              row[`group3_${field}`] = 0;
            });

            auditAmountFields.forEach((field) => {
              row[`group3_${field}`] = 0;
            });
          }
        }

        seriesDetails.forEach((detail) => {
          const { productSeriesCode } = detail;
          const mapping = productSeriesMapping[productSeriesCode];

          if (mapping) {
            const inputModuleKey = mapping.input;
            const seriesModuleKey = mapping.series;

            totalAmountFields.forEach((field) => {
              row[`${inputModuleKey}_${field}`] = rowIndex === 0 ? detail[field] || 0 : 0;
            });

            const subjectList = detail.detailSubjectList || [];
            const subject = subjectList[rowIndex];

            if (subject) {
              row[`${seriesModuleKey}_firstSubjectName`] = subject.firstSubjectName;
              row[`${seriesModuleKey}_secondSubjectName`] = subject.secondSubjectName;
              row[`${seriesModuleKey}_schemeAmout`] = subject.schemeAmout;

              applyAmountFields.forEach((field) => {
                row[`${seriesModuleKey}_${field}`] = subject[field] || 0;
              });

              auditAmountFields.forEach((field) => {
                row[`${seriesModuleKey}_${field}`] = subject[field] || 0;
              });
            } else {
              row[`${seriesModuleKey}_firstSubjectName`] = '';
              row[`${seriesModuleKey}_secondSubjectName`] = '';
              row[`${seriesModuleKey}_schemeAmout`] = 0;

              applyAmountFields.forEach((field) => {
                row[`${seriesModuleKey}_${field}`] = 0;
              });

              auditAmountFields.forEach((field) => {
                row[`${seriesModuleKey}_${field}`] = 0;
              });
            }
          }
        });

        if (rowIndex === 0) {
          this.calculateSeriesSubtotal(row, totalAmountFields);
          this.calculateApplyAuditSubtotal(row, totalAmountFields);
        }

        result.push(row);
      }

      return result;
    },
    showColumn(field) {
      return this.paramChooseKey.includes(field);
    },
    showModule(field) {
      return this.moduleChooseKey.includes(field);
    },
    footerMethod({ columns, data }) {
      const footerData = [
        columns.map((column, _columnIndex) => {
          if (_columnIndex === 0) {
            return '合计';
          }
          const { property } = column;
          if (
            property
            && (property.endsWith('Amount') || property.endsWith('amount'))
          ) {
            let total = 0;
            this.tableData.forEach((v) => {
              total += v[property] || 0;
            });
            return total;
          }
          return null;
        }),
      ];
      return footerData;
    },
    spanMethod({
      row, _rowIndex, column, columnIndex,
    }) {
      const { property } = column;
      const spanFields = [
        'dateScope',
        'companyName',
        'customerName',
        'companySaleAmount',
        'sellThroughAmount',
        'companySaleSellThroughAmount',
        'zltrAmount',
        'gstctrAmount',
        'scjctrAmount',
        'zxtrAmount',
        'gstctrzyAmount',
        'blAmount',
        'zrcsgjAmount',
        'trTotalAmount',
        'group3_zltrAmount',
        'group3_gstctrAmount',
        'group3_scjctrAmount',
        'group3_zxtrAmount',
        'group3_gstctrzyAmount',
        'group3_blAmount',
        'group3_zrcsgjAmount',
        'group3_trTotalAmount',
        'group4_zltrAmount',
        'group4_gstctrAmount',
        'group4_scjctrAmount',
        'group4_zxtrAmount',
        'group4_gstctrzyAmount',
        'group4_blAmount',
        'group4_zrcsgjAmount',
        'group4_trTotalAmount',
        'group6_zltrAmount',
        'group6_gstctrAmount',
        'group6_scjctrAmount',
        'group6_zxtrAmount',
        'group6_gstctrzyAmount',
        'group6_blAmount',
        'group6_zrcsgjAmount',
        'group6_trTotalAmount',
        'group8_zltrAmount',
        'group8_gstctrAmount',
        'group8_scjctrAmount',
        'group8_zxtrAmount',
        'group8_gstctrzyAmount',
        'group8_blAmount',
        'group8_zrcsgjAmount',
        'group8_trTotalAmount',
        'group10_zltrAmount',
        'group10_gstctrAmount',
        'group10_scjctrAmount',
        'group10_zxtrAmount',
        'group10_gstctrzyAmount',
        'group10_blAmount',
        'group10_zrcsgjAmount',
        'group10_trTotalAmount',
        'group12_zltrAmount',
        'group12_gstctrAmount',
        'group12_scjctrAmount',
        'group12_zxtrAmount',
        'group12_gstctrzyAmount',
        'group12_blAmount',
        'group12_zrcsgjAmount',
        'group12_trTotalAmount',
        'group14_zltrAmount',
        'group14_gstctrAmount',
        'group14_scjctrAmount',
        'group14_zxtrAmount',
        'group14_gstctrzyAmount',
        'group14_blAmount',
        'group14_zrcsgjAmount',
        'group14_trTotalAmount',
      ];
      if (spanFields.includes(property)) {
        if (row.customerRowIndex === 0) {
          return {
            rowspan: row.customerTotalRows,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
      return {
        rowspan: 1,
        colspan: 1,
      };
    },
  },
};
</script>
<style scoped lang="less">
.page {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.page-search {
  flex-shrink: 0;
  margin-bottom: 16px;
}
.search-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
}
.search-row .el-date-picker,
.search-row .el-input {
  width: 232px;
  margin-right: 10px;
}
.search-row .el-button {
  margin-left: 10px;
}
.select-row {
  display: flex;
  align-items: center;
}
.select-row .el-button {
  margin-left: 5px;
}
.page-table {
  flex: 1;
  min-height: 0;
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: 16px;
}
.pagination {
  flex-shrink: 0;
  text-align: right;
  margin-bottom: 16px;
}
.table-column-box {
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
  flex-wrap: wrap;
}
.el-checkbox-group {
  margin-right: 10px;
  width: 90%;
  padding-bottom: 20px;
}
.el-checkbox {
  margin-right: 15px;
  margin-bottom: 8px;
}
.vxe-table {
  width: 100%;
}

/deep/.table-header {
  background: #e8e8e8;
}
</style>
